import { type SVGProps } from 'react';
import { Store, Gem, Cpu, Globe, Gauge, Building2 } from 'lucide-react';

// Wrapper components to match the SVGProps interface expected by LogoCarousel
export function RetailIcon(props: SVGProps<SVGSVGElement>) {
  return <Store {...props} />;
}

export function FashionIcon(props: SVGProps<SVGSVGElement>) {
  return <Gem {...props} />;
}

export function ElectronicsIcon(props: SVGProps<SVGSVGElement>) {
  return <Cpu {...props} />;
}

export function TourismIcon(props: SVGProps<SVGSVGElement>) {
  return <Globe {...props} />;
}

export function AutomotiveIcon(props: SVGProps<SVGSVGElement>) {
  return <Gauge {...props} />;
}

export function RealEstateIcon(props: SVGProps<SVGSVGElement>) {
  return <Building2 {...props} />;
}